<template>
  <div class="order-process">
    <div class="no-process" v-if="(!info.procs || info.procs.length === 0) && !loading">
      暂时没有审批进程
    </div>
    <ul class="process-list" v-if="info.procs && info.procs.length !== 0">
      <li class="item" v-for="(item, index) in info.procs" :key="index">
        <span class="step">{{item.step}}</span><span class="date">{{item.finishTime}}</span>
        <span class="top"></span>
        <span class="bottom"></span>
        <span class="circle"></span>
      </li>
    </ul>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
import Spinner from 'components/spinner/spinner'
export default {
  components: {
    Spinner
  },
  data () {
    return {
      info: {},
      loading: false,
      isFbs: 0
    }
  },
  created () {
    this.token = this.$cache.getUserToken()
    this.orderNo = this.$route.params.orderNo
    this.isFbs = Number(this.$route.query.isFbs) || 0
    this.isFbs && this._fetchData()
  },
  methods: {
    onConfirm () {
      this.isPerfectInfo = false
    },
    onCancel () {
      this.isPerfectInfo = false
    },
    _fetchData () {
      let vm = this
      this.loading = true
      this.$ajax({
        url: '/center/getOrderProcess.jhtml',
        params: {
          no: vm.orderNo,
          uid: vm.token.uid
        },
        done (info) {
          vm.info = info
        },
        fail (msg) {
          vm.$dialog(msg)
        },
        always () {
          vm.loading = false
        }
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '../../common/css/mixmin'
.order-process
  overflow auto
  height 100%
.no-process
  height px2rem(800px)
  line-height px2rem(800px)
  text-align center
  font-size px2rem(32px)
.process-list
  margin 0
  padding px2rem(18px) px2rem(72px) 0
  .item
    height px2rem(80px)
    line-height px2rem(80px)
    font-size px2rem(28px)
    color rgb(51, 51, 51)
    // border-left 1px solid rgba(18, 119, 163, 0.75)
    position relative
    list-style none
    padding-left px2rem(60px)
    .top,.bottom
      display block
      position absolute
      width 1px
      background-color rgba(18, 119, 163, 0.75)
      height 50%
      left 0px
      top 0
    .bottom
      top 50%
    .circle
      content ''
      position absolute
      width px2rem(10px)
      height px2rem(10px)
      border 1px solid rgba(18, 119, 163, 0.75)
      border-radius px2rem(5px)
      background-color #fff
      left -(px2rem(4px))
      top 50%
      margin-top -(px2rem(5px))
      z-index 2
    &:first-child
      .top
        display none
      .circle
        background-color rgba(18, 119, 163, 1)
    &:last-child
      .bottom
        display none
    .step
      float left
    .date
      float right
      color rgb(153, 153, 153)
</style>



// WEBPACK FOOTER //
// order-process.vue?a1802696